import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/hours'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(hours) {
    return http.post(`${resource}`, hours)
  },
  getSchedule(uuid, params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}/${uuid} ${paramsString}`)
  },
  update(hours, uuid) {
    return http.put(`${resource}/${uuid}`, hours)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
